<template>
    <div class="add-customer-dialog">
        <el-dialog :visible="visible" :title="title" destroy-on-close :width="width" :close-on-click-modal='false'
            :close-on-press-escape='false' @close="closeVisible(false)">
            <div class="add-customer-paper-form-box">
                <el-input type="text" class="customer-select" placeholder="请输入"
                    v-model.trim="addNewMainData.pageName" clearable
                    @input="data => inputChange(data)" />
            </div>
            <span slot="footer">
                <el-button size="mini" @click="closeVisible(false)">取消</el-button>
                <el-button type="primary" size="mini" @click="confirmHandle">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { ref } from '@vue/composition-api';
import _ from 'lodash';
export default {
    components: { },
    props: {
        title: {
            type: String,
            default: () => {
                return '';
            }
        },
        width: {
            type: String,
            default: () => {
                return '40%';
            }
        }

    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const emit = setupContext.emit;
        const _addNewMainData = {
            pageName: ''
        };
        const addNewMainData = ref(_.cloneDeep(_addNewMainData));
        const showParams = ref({});
        const visible = ref(false);
        const show = (val = {}) => {
            visible.value = true;
            showParams.value = val;
            initDialog(val);
        };
        const initDialog = (val) => {
            addNewMainData.value = Object.assign({}, _addNewMainData, val);
        };

        const inputChange = (data, prop) => {
            addNewMainData.value[prop] = data;
        };

        const closeVisible = (val = false) => {
            visible.value = val;
            showParams.value = {};
        };
        const confirmHandle = () => {
            // if (_.isNil(showParams.value.id)) {
            //     visible.value = false;
            //     showParams.value = {};
            //     emit('openEditHtml');
            // } else {
            //     }
            emit('savePaper', addNewMainData.value);
        };
        return {
            addNewMainData,
            visible,
            show,
            inputChange,
            closeVisible,
            confirmHandle
        };
    }
};
</script>
<style lang="less" scoped>

</style>
